import { render, staticRenderFns } from "./SBPRecoveryDialog.vue?vue&type=template&id=570bea7a&"
import script from "./SBPRecoveryDialog.vue?vue&type=script&lang=js&"
export * from "./SBPRecoveryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports